package one.healthium.health_tools.ui.models

import androidx.compose.runtime.Immutable
import kotlin.time.Instant

@Immutable
data class UpdateWeightUiModel(
    val currentWeight: Float,
    val date: Instant?,
)
